export default __webpack_public_path__ + "static/media/cachet.e302356f.svg";